import type { CardOption } from 'components/IAP/planningView/cardOptions';
import { STEPPER_FORM_WIDGETS } from 'components/IAP/planningView/stepperFormStatus';

import type { RelatedForm } from './seatCatalog';

const widgetByBaseId = new Map(
  Object.entries(STEPPER_FORM_WIDGETS).map(([widgetName, config]) => [
    config.baseId,
    widgetName,
  ])
);

/** Catalog forms that have a Planning-P card, in catalog order. */
export function formOptionsForSeat(forms: readonly RelatedForm[]): CardOption[] {
  const options: CardOption[] = [];
  for (const form of forms) {
    const widgetName = widgetByBaseId.get(form.baseId);
    if (!widgetName) continue;
    options.push({ label: form.label, value: widgetName });
  }
  return options;
}
